import { render, staticRenderFns } from "./exam_processing_speed.vue?vue&type=template&id=10299df2&"
import script from "./exam_processing_speed.vue?vue&type=script&lang=js&"
export * from "./exam_processing_speed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports